import React from 'react';
import { Text } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import { getDateString } from '../../../../../../../../../../../../../../../utils/dateUtil';

const ExpirationDateCell = ({ value }) => (
  <Text color="greyScale.600" whiteSpace="nowrap">
    {getDateString(value, 'MM/DD/YYYY')}
  </Text>
);

ExpirationDateCell.propTypes = {
  value: PropTypes.string,
  row: PropTypes.shape({ original: PropTypes.oneOfType([PropTypes.object, PropTypes.array]) })
};

export default ExpirationDateCell;
